import { memo } from 'react'

const IconProfileFill = ({
  fill,
  width,
  height,
}: {
  fill: string
  width: string
  height: string
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.9971 12.5C14.2695 12.5001 16.3667 13.0948 17.9708 14.1006C19.5692 15.103 20.734 16.5555 20.9854 18.2764C21.1111 19.1374 20.4452 19.7277 19.8165 19.9414C15.6393 21.3611 9.07882 21.3457 4.29399 19.9375C3.63851 19.7446 2.86865 19.1457 3.01665 18.2158L3.07817 17.8994C3.43597 16.3332 4.55597 15.0125 6.05083 14.083C7.65119 13.0879 9.73783 12.5 11.9971 12.5Z'
        fill={fill}
      />
      <path
        d='M12 3C14.3472 3.00004 16.25 4.90282 16.25 7.25C16.25 9.59719 14.3472 11.5 12 11.5C9.65284 11.5 7.75005 9.59721 7.75005 7.25C7.75005 4.90279 9.65284 3 12 3Z'
        fill={fill}
      />
    </svg>
  )
}

export default memo(IconProfileFill)
